import React from 'react';
import styles from './Clinic.module.scss';
import api from "../../../helpers/api";
import TreatmentSettings from "../../../components/TreatmentSettings/TreatmentSettings";
import AccountDetails from "../../../components/AccountDetails/AccountDetails";
import ClinicDetails from "../../../components/ClinicDetails/ClinicDetails";
import PlatformsTable from "../../../components/PlatformsTable/PlatformsTable";
import ApplicatorsTable from "../../../components/ApplicatorsTable/ApplicatorsTable";
import {connect} from "react-redux";
import {setPageHeader} from "../../../store/app-slice";
import UsersTable from "../../../components/UsersTable/UsersTable";

class DistributorClinic extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clinicId: this.props.match.params.id ? this.props.match.params.id : null,
            clinicName: '',
            clinic: null,
        }
    }

    async componentDidMount() {
        let clinicId = this.props.match.params.id ? this.props.match.params.id : null;
        await this.getClinic()

        if (!clinicId) {

        }
        this.setState({clinicId: clinicId})
    }

    componentWillUnmount() {
        this.props.dispatch(setPageHeader(null));
    }

    async getClinic() {
        let route = `account/clinic?clinic_id=${this.props.match.params.id}`;
        let res = await api.get(route)

        if (res.status !== 200) {
            // this.props.router.push('/chain/404')    //programmatically route changing
            return;
        }

        this.props.dispatch(setPageHeader(res.data.data.name));
        this.setState({clinic: res.data.data}, () => {
            // console.log('>>>', this.state.clinic)
        })
    }

    render() {
        let clinicId = parseInt(this.state.clinicId);
        let clinic = this.state.clinic;

        return (
            <div className={styles.container}>
                {
                    this.state.clinicName ?
                        <div className={` ${styles.clinicNameContainer}`}>
                            {this.state.clinicName}
                        </div>
                        : null
                }

                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <AccountDetails clinicId={clinicId} userType={4}/>
                    </div>
                    <div className={styles['box']}>
                        <ClinicDetails userType={4} clinicType={2} clinicId={clinicId} onClinicNameChange={(name) => this.setState({clinicName: name})}/>
                    </div>
                    <div className={styles['box']}>
                        <TreatmentSettings userType={4} clinicId={clinicId} />
                    </div>
                </div>

                <div>
                    {/*<div className={styles['flex-row']}>*/}
                    {/*    <div className={styles['box']}>*/}
                    {/*        <TreatmentsTable userType={3}*/}
                    {/*                         clinicId={clinicId}*/}
                    {/*                         header={$t('global.treatments.clinicTreatments')}*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className={styles['flex-row']}>
                        <div className={styles['box']}>
                            {/*<PlatformsGrid userType={2} clinicId={clinicId} perPage={5}/>*/}
                            <PlatformsTable userType={4} clinicId={clinicId} perPage={10} getUsage={false} />
                        </div>
                    </div>
                    <div className={styles['flex-row']}>
                        <div className={styles['box']}>
                            {/*<ApplicatorsGrid userType={2} clinicId={clinicId} perPage={5}/>*/}
                            <ApplicatorsTable userType={4} clinicId={clinicId} perPage={10}/>
                        </div>
                    </div>
                    <div className={styles['flex-row']}>
                        <div className={styles['box']}>
                            <UsersTable userType={4} clinicId={clinicId} clinic={clinic}/>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

// export default DistributorClinic;

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(DistributorClinic);
